import React from "react";
import { Grid, Typography, useTheme } from "@material-ui/core";

export const PaymentTerminalBadge = ({ paymentTerminal }) => {
  const theme = useTheme();
  if (paymentTerminal == null) return null;

  const hasTerminal = paymentTerminal === 1 || paymentTerminal === true;

  return (
    <Grid item xs={12}>
      <Typography
        variant="body2"
        style={{
          color: hasTerminal ? theme.palette.primary.main : theme.palette.error.main,
          fontWeight: 500,
        }}
      >
        La unidad seleccionada {!hasTerminal && "no "}cuenta con terminal bancaria en ruta
      </Typography>
    </Grid>
  );
};
